import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.inventory-history-item-form', () => {
  import('./internal/inventory-history-item-form').then(({ default: Component }) => Component());
});
